import React, {Component} from 'react';

import url from 'url'
import axios from 'axios'
import _ from 'lodash'

//import OAuth from 'oauth-1.0a'

import {userApiUrl} from "./application/config";
//import {oAuthSecret, canvasKey} from "./application/config";
import medLogo from './assets/logoMediatheek.png'
import './App.css';

import Leeslijst from './component/Leeslijst'
import { version } from './version'
import {LocaleManager, ApplicationPath} from "med-class";


const query = url.parse(window.location.href, true).query;
const prod = process.env.NODE_ENV === 'production';
const user = prod ? window.custom_canvas_user_login_id : query.user;
const cursus = prod ? window.resource_link_id : query.cursus;
const roles = prod ? window.roles : 'Instructor';
const subscriber = prod ? window.subscriber : 'canvas';

/*console.log('QUERY', url.parse(window.location.href, true).query)
console.log('PROCESS', process)
console.log('PROD', prod)
console.log('USER', user)*/
//TODO: veld subscriber toevoegen, bv. 'sharepoint', 'canvas', ...

//BELANGRIJK
/*
* Na het builden en deployen moet het bestand index.php verwijderd worden op de server en het bestand index.html hernoemd worden naar index.php
* */

//Dany: 600002138
//Lennert: 600007498

//vanuit post object:
//context_id >> enkel dit gebruiken
//custom_canvas_course_id >> niet dit
//user_id

//const oauth_signature = "Q+2MWfvs9vBQMWpgHv4EpC37NVc="
//const oauth_consumer_key = "canvas-ahs"
//const oauth_signature_method = "HMAC-SHA1"
//const oauth_timestamp = "1530791905"
//const oauth_nonce = "Bj5p9SzvY4j8A1Yc062xe2h6HgKq0EF5seYEwMjVQw"
//const oauth_version = "1.0"
//const launch_presentation_return_url = "1.0"

class App extends Component {

    constructor(props) {
        super(props);


        this.state = {
            edit: false,
            user: user,
            cursus: cursus,
            subscriber: subscriber,
            server: 'busy',
            cursussen: [],
            localeManager: null
        }
    }

    componentDidMount() {

        /*const oauth = OAuth({
            consumer: {
                key: canvasKey,
                secret: oAuthSecret
            },
            signature_method: 'HMAC-SHA1',
            hash_function(base_string, key) {
                return crypto.createHmac('sha1', key).update(base_string).digest('base64');
            }
        });*/

        //console.log('OAUTH', oauth)


        let url = `${userApiUrl}?userID=${this.state.user}&cursus=${this.state.cursus}&function=getCanvasZoeklijsten&subscriber=${this.state.subscriber}`;

        axios.get(url).then((response) => {
            let zoeklijsten = _.orderBy(
                response.data.zoeklijsten.zoeklijsten,
                [zoeklijst => zoeklijst.label.toLowerCase()]);
            let cursussen = _.orderBy(
                response.data.cursussen,
                [cursus => cursus.label.toLowerCase()]);
            this.setState({server: 'ready', zoeklijsten, cursussen});
        })

        const localeManager = new LocaleManager(ApplicationPath.localeFilesFolder)
        localeManager.init('nl').then(() => this.setState({localeManager}))
    }

    koppelZoeklijst = (zoeklijst) => {
        let url = `${userApiUrl}?function=addCursusZoeklijst&cursus=${this.state.cursus}&zoeklijst=${zoeklijst.id}&subscriber=${this.state.subscriber}`;
        console.log('KOPPEL', url)

        axios.get(url).then(response => {
            let newCursus = response.data;
            this.setState({
                cursussen: _.concat(this.state.cursussen, newCursus)
            })
        })
    }

    ontkoppelZoeklijst = (zoeklijst) => {
        let cursus = _.find(this.state.cursussen, cursus => cursus.zoeklijst === zoeklijst.id);
        let url = `${userApiUrl}?function=deleteCursusZoeklijst&cursusZoeklijstId=${cursus.id}&subscriber=${this.state.subscriber}`;

        console.log('ONTKOPPEL', url)
        axios.get(url).then(response => {
            let cursussen = _.filter(this.state.cursussen, cursus => zoeklijst.id !== cursus.zoeklijst);
            this.setState({cursussen})
        })
    }

    onEditClick = () => {
        this.setState(
            {edit: !this.state.edit}
        )
    }

    render() {

        const {server, zoeklijsten, cursussen, edit, localeManager} = this.state;
        const canEdit = roles.indexOf('Instructor') > -1

        if (!localeManager) return null

        if (server === 'busy') return <p>Data ophalen...</p>

        let partition = _.partition(zoeklijsten, zoeklijst => {
            let rv = false;
            _.each(cursussen, cursus => {
                if (zoeklijst.id === cursus.zoeklijst) rv = true
            })
            return rv;
        });

        let gekoppeldeZoeklijsten = partition[0];
        let nietGekoppeldeZoeklijsten = partition[1];

        let andereGebruikersLijsten = _.filter(cursussen, cursus => {
            let rv = true;
            _.each(zoeklijsten, zoeklijst => {
                if (zoeklijst.id === cursus.zoeklijst) rv = false
            })
            return rv;
        })

        return (

            <div className='zoeklijst-content'>

                <header>
                    <img src={medLogo} alt="logo" width="300"/>
                </header>
                {canEdit && <p>
                    Je kan hier leeslijsten die je op ons mediatheek portaal hebt aangemaakt koppelen aan deze cursus.
                </p>}

                {canEdit && <button onClick={this.onEditClick}>{this.state.edit ? 'Gereed' : 'Bewerk'}</button>}
                <h3>Gekoppelde leeslijsten aan deze cursus</h3>
                <div className="item-group-container">
                    {
                        andereGebruikersLijsten.map(cursus => <Leeslijst
                            localeManager={localeManager}
                            uthor={cursus.userUpn}
                            key={cursus.id}
                            leeslijst={cursus} />)
                    }
                    {
                        gekoppeldeZoeklijsten.map(zoeklijst => <Leeslijst
                            localeManager={localeManager}
                            key={zoeklijst.id}
                            leeslijst={zoeklijst}
                            edit={edit}
                            buttonLabel='Ontkoppel'
                            callback={this.ontkoppelZoeklijst}/>)
                    }
                </div>

                {this.state.edit && <div>
                    <h3>Niet gekoppelde leeslijsten aan deze cursus</h3>
                    <div className="item-group-container">
                        {
                            nietGekoppeldeZoeklijsten.map(zoeklijst => <Leeslijst
                                localeManager={localeManager}
                                key={zoeklijst.id}
                                leeslijst={zoeklijst}
                                edit={edit}
                                buttonLabel='Koppel'
                                callback={this.koppelZoeklijst}/>)
                        }
                    </div>
                </div>
                }

                <footer>v. {version}</footer>
            </div>
        );
    }

}

export default App;
